module.exports = __webpack_public_path__ + "static/media/popup-girl.30e1bd50.png";